/**
 * vmからconsole.infoするためのmixin
 */
export default {
  methods: {
    info(...args: any[]) {
      console.info(...args);
    },
    warn(...args: any[]) {
      console.warn(...args);
    }
  }
};
